import React, { useEffect, useState } from "react";
import { Button, Typography } from "antd";
import {
  SubscriptionWrapper,
  HeaderSection,
  SubscriptionTable,
  StyledContent,
} from "./styles";
import { useKeycloak } from "@react-keycloak/web";
import { useDispatch, useSelector } from "react-redux";
import NoPermission from "../../NoPermission";
import LoginLoader from "../Loader/LoginLoader";
import {
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

const UserProfile = () => {
  const { keycloak } = useKeycloak();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userEmail = keycloak?.idTokenParsed?.email;
  const userName = keycloak?.idTokenParsed?.name || "User";

  const [dataLoaded, setDataLoaded] = useState(true);

  const subscriptionData = [
    {
      key: "1",
      subscription: "Free",
      audio: "Unlimited",
      video: "Unlimited", 
      text: "Unlimited",
      renewalDate: "N/A",
    },
  ];

  const columns = [
    { title: "Subscription", dataIndex: "subscription", key: "subscription" },
    { title: "Audio Generated", dataIndex: "audio", key: "audio" },
    { title: "Videos Generated", dataIndex: "video", key: "video" },
    { title: "Text Generated", dataIndex: "text", key: "text" },
    { title: "Renewal Date", dataIndex: "renewalDate", key: "renewalDate" },
  ];

  return keycloak.authenticated ? (
    <StyledContent>
    <SubscriptionWrapper>
      {!dataLoaded || loading ? (
        <div>
          <LoginLoader />
        </div>
      ) : (
        <>
          <Button
            type="link"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate("/NewsList")}
            style={{
              top: "10px",
              fontSize: "16px",
              margin: 0,
              fontWeight: "500",
              font: "Inter",
            }}
          >
            Back
          </Button>
          <HeaderSection>
            <div>
              <Title level={2}>Welcome {userName}</Title>
              <Text type="secondary">
                Your free account with unlimited access to all features
              </Text>
            </div>
          </HeaderSection>
          <SubscriptionTable
            columns={columns}
            dataSource={subscriptionData}
            pagination={false}
            bordered
          />
        </>
      )}
    </SubscriptionWrapper>
    </StyledContent>
  ) : (
    <NoPermission />
  );
};

export default UserProfile;
